export const FETCH_JOBS = 'FETCH_JOBS' as const;
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS' as const;
export const FETCH_JOBS_FAIL = 'FETCH_JOBS_FAIL' as const;
export const FETCH_JOBS_CANCEL = 'FETCH_JOBS_CANCEL' as const;
export const CLEAR_JOBS = 'CLEAR_JOBS' as const;

export const FETCH_JOBS_PAGE = 'FETCH_JOBS_PAGE' as const;
